<div class="header">
  <div class="header-logo">
    <svg-icon
      [routerLink]="['dashboard']"
      src="assets/svg/lighthouseLogo2025.svg"
    ></svg-icon>
  </div>
  <div *ngIf="isDocsRoute" class="header-docs-meta">
    <div class="header-docs-meta__title">Lighthouse Mobile API Reference</div>
    <div class="header-docs-meta__version">Version: 1.0.0</div>
  </div>
  <div *ngIf="!isDocsRoute && (currentAccount || loggedIn)" class="header-account">
    <div class="account-name">
      <div class="account-name-line"></div>
      <div class="account-name-text">
        {{ currentAccount?.name }}
      </div>
      <div class="account-name-line"></div>
    </div>
    <div *ngIf="selectedFacilities && selectedFacilities.length <= 3" class="selected-locations">
      <div
        *ngFor="let facility of selectedFacilities"
        class="selected-location"
      >
        <div class="selected-location-text">{{ facility.name }}</div>
        <div class="selected-location-line"></div>
      </div>
    </div>
    <div *ngIf="selectedFacilities && selectedFacilities.length > 3">
      {{ selectedFacilities.length }} Facilities Selected
    </div>
  </div>
  <div *ngIf="!isDocsRoute && loggedIn" class="header-options">
    <div class="icons">
      <button
        *ngIf="apps && apps!.length > 1"
        mat-fab
        class="icon-button"
        [matMenuTriggerFor]="appMenu"
      >
        <svg-icon
          src="assets/svg/phone.svg"
          [svgStyle]="{
            'width.px': '22.146',
            'height.px': '26.5'
          }"
          svgClass="lightBlueBtn"
        ></svg-icon>
      </button>
      <mat-menu class="mat-menu-elaphant vertical-menu" #appMenu="matMenu">
        <button
          *ngFor="let app of apps"
          [ngClass]="{ selected: isCurrentApp(app) }"
          mat-menu-item
          (click)="changeApp(app)"
          [disabled]="isCurrentApp(app)"
        >
          {{ app.name }}
        </button>
      </mat-menu>
      <button
        *ngIf="facilities && facilities.length > 1"
        mat-fab
        class="icon-button"
        [matMenuTriggerFor]="facilityMenu"
      >
        <svg-icon
          src="assets/svg/facilities.svg"
          [svgStyle]="{
            'width.px': '24.081',
            'height.px': '26.5'
          }"
          svgClass="lightBlueBtn"
        ></svg-icon>
      </button>
      <mat-menu
        class="mat-menu-elaphant vertical-menu facility-menu"
        #facilityMenu="matMenu"
      >
        <div class="facility-buttons">
          <button mat-button color="blueBayouxDark" (click)="selectAllFacilities($event)">Select All</button>
          <button mat-button color="blueBayouxDark" (click)="selectNoFacilities($event)">Select None</button>
        </div>
        <button
          class="facility"
          *ngFor="let facility of facilities"
          [disabled]="facility.selected && selectedFacilities!.length === 1"
          mat-menu-item
        >
          <mat-checkbox
            [checked]="!!facility.selected"
            (change)="onFacilitySelectedChange(facility)"
            (click)="$event.stopPropagation()"
          >
            {{ facility.name }}
          </mat-checkbox>
        </button>
      </mat-menu>

      <button
        *ngIf="accounts && accounts!.length > 1"
        mat-fab
        class="icon-button"
        [matMenuTriggerFor]="accountMenu"
      >
        <svg-icon
          src="assets/svg/accounts.svg"
          [svgStyle]="{
            'width.px': '27.5',
            'height.px': '26.5'
          }"
          svgClass="lightBlueBtn"
        ></svg-icon>
      </button>
      <mat-menu class="mat-menu-elaphant vertical-menu" #accountMenu="matMenu">
        <button
          *ngFor="let account of accounts"
          [ngClass]="{ selected: isCurrentAccount(account) }"
          mat-menu-item
          (click)="changeAccount(account)"
          [disabled]="isCurrentAccount(account)"
        >
          {{ account?.name }}
        </button>
      </mat-menu>
      <button mat-fab class="icon-button" (click)="toggleNotifications()">
        <span
          [matBadge]="unreadNotificationsCount"
          [matBadgeHidden]="!unreadNotificationsCount"
          matBadgePosition="after"
          matBadgeColor="warn"
        >
          <svg-icon
            src="assets/svg/bell.svg"
            [svgStyle]="{
              'width.px': '26.109',
              'height.px': '26.085'
            }"
            svgClass="lightBlueBtn"
          ></svg-icon>
        </span>
      </button>

      <button mat-fab class="icon-button" [matMenuTriggerFor]="userMenu">
        <svg-icon
          src="assets/svg/person-circle.svg"
          [svgStyle]="{
            'width.px': '26.109',
            'height.px': '26.085'
          }"
          svgClass="lightBlueBtn"
        ></svg-icon>
      </button>
      <mat-menu class="mat-menu-elaphant vertical-menu" #userMenu="matMenu">
        <button mat-menu-item (click)="goToUserPreferences()">
          <mat-icon>account_circle</mat-icon>
          <span>User Preferences</span>
        </button>
        <button mat-menu-item (click)="logOut()">
          <mat-icon>close</mat-icon>
          <span>Log Out</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>
